<template>
  <v-container class="pt-6">
    <v-card class="elevation-2 mb-6">
      <v-card-title class="px-9 pt-7">
        Přehled tiskáren
      </v-card-title>

      <v-card-text>

        <PrintersFilters @filter="setFiltersAction"/>

        <v-data-table
          :headers="printer.headers"
          :items="printer.items"
          :options.sync="printer.options"
          :server-items-length="printer.serverItemsLength"
          :loading="printer.loading"
          item-key="serialNumber"
          class="elevation-0"
        >
          <template v-slot:item.serialNumber="{ item }">
            <router-link
              :to="{ name: 'printers.detail', params: { serialNumber: item.serialNumber } }"
            >{{ item.serialNumber }}
            </router-link>
          </template>

          <template v-slot:item.type="{ item }">
            <PrinterType :type=" item.type"/>
          </template>

          <template v-slot:item.createdAt="{ item }">
            {{ $dayjs(item.createdAt).format('D.M.YYYY') }}
            <br>
            {{ $dayjs(item.createdAt).format('H:mm') }}
          </template>

          <template v-slot:item.updatedAt="{ item }">
            {{ $dayjs(item.updatedAt).format('D.M.YYYY') }}
            <br>
            {{ $dayjs(item.updatedAt).format('H:mm') }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="hidePrinter(item.serialNumber)"
                  icon
                  color="blue-grey"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Skrýt tiskárnu</span>
            </v-tooltip>
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import PrintersFilters from '@/components/PrintersFilters.vue';
import { setFilters } from '@/components/mixins/setFilters';
import PrinterType from '@/components/PrinterType.vue';

export default {
  name: 'PrintersAll',
  mixins: [setFilters],
  components: {
    PrinterType,
    PrintersFilters,
  },
  data() {
    return {
      printer: {
        headers: [
          {
            text: 'Sériové číslo',
            value: 'serialNumber',
            width: '60px',
          },
          {
            text: 'Název',
            value: 'name',
            width: '120px',
          },
          {
            text: 'Zákazník',
            value: 'customer',
            width: '140px',
          },
          {
            text: 'Zákaznický kód',
            value: 'code',
            width: '140px',
          },
          {
            text: 'Stav',
            value: 'status',
            width: '60px',
            sortable: false,
          },
          {
            text: 'Stav zařízení',
            value: 'statusDevice',
            width: '60px',
            sortable: false,
          },
          {
            text: 'Chyba',
            value: 'errorState',
            width: '60px',
            sortable: false,
          },
          {
            text: 'Upraveno',
            value: 'updatedAt',
            width: '60px',
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 100,
          sortBy: ['serialNumber'],
          sortDesc: [false],
        },
        loading: false,
        serverItemsLength: 0,
      },
      printerFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    };
  },
  methods: {
    ...mapActions({
      searchPrinters: 'printers/searchPrinters',
      deletePrinter: 'printers/deletePrinter',
    }),
    loadPrinters() {
      if (this.printer.loading) {
        return;
      }
      this.printer.loading = true;
      const searchParams = {
        filterParams: this.$route.query,
        options: this.printer.options,
      };
      this.searchPrinters(searchParams).then((response) => {
        this.printerFooter.totalElements = response.data.totalElements;
        this.printer.items = response.data.items;
        this.printer.serverItemsLength = response.data.totalElements;
        this.cancel = null;
      }).finally(() => {
        this.printer.loading = false;
      });
    },
    setFiltersAction(filters) {
      this.printer.options.page = 1;
      this.setFilters(filters);
    },
    hidePrinter(serialNumber) {
      this.$confirm('<p class="text--primary">Tiskárna bude v seznamu znovu zobrazena po aktualizaci jejího stavu</p>', {
        title: 'Skrýt tiskárnu v seznamu?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'primary',
        width: 600,
      }).then((result) => {
        if (result) {
          this.printer.loading = true;
          this.deletePrinter(serialNumber)
            .finally(() => {
              this.printer.loading = false;
              this.loadPrinters();
            });
        }
      });
    },
  },
  watch: {
    'printer.options': {
      handler() {
        this.loadPrinters();
      },
    },
    '$route.query': {
      handler() {
        this.loadPrinters();
      },
    },
  },
  created() {
    this.loadPrinters();
  },
};
</script>
